module.exports = __webpack_public_path__ + "img/IMG_2254_L_Black_MockedUp.07c3aac7.jpg";